import type { FC } from 'react';

import { useFeature } from '../../services/features/reactBindings/hooks';
import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { HeaderModal } from '../../store/slices/header/types';
import { useNickNameInfoSlice } from '../../store/slices/nickname/selectors';
import { nickNameInfoActions } from '../../store/slices/nickname/slice';
import type { TabProps } from '../tabs/Tabs';

import { SettingsConnected } from './SettingsConnected';
import { SettingsModal } from './SettingsModal';

interface SettingsModalConnectedProps {
  gameSpecificTab?: TabProps[];
}

export const SettingsModalConnected: FC<SettingsModalConnectedProps> = () => {
  const dispatch = useCoreDispatch();

  const openedModal = useHeaderSlice.getCoreOpenedModal();
  const heightAdjustment = useConfigSlice.playAreaDimensions()?.height;
  const isNickNameEditOpen = useNickNameInfoSlice.getIsNickNameEditOpen();
  const newLayout = useFeature('newLayout');

  const handleBack = (): void => {
    dispatch(nickNameInfoActions.setIsNickNameEditOpen(false));
  };

  const handleClose = (): void => {
    dispatch(headerActions.setOpenedModal(null));
    dispatch(nickNameInfoActions.setIsNickNameEditOpen(false));
  };

  return (
    <SettingsModal
      newLayout={newLayout}
      heightAdjustment={heightAdjustment}
      open={openedModal === HeaderModal.Settings}
      onBack={isNickNameEditOpen ? handleBack : undefined}
      onClose={handleClose}
    >
      <SettingsConnected />
    </SettingsModal>
  );
};
